import { createStockAmount, createStockAmountEdit } from "./amount/amount"
import { StocksDashboardCtrl } from "./dashboard/dashboard"
import { StockEditCtrl } from "./edit/edit"
import { FertiliserStockEditCtrl } from "./edit/fertiliser/editFertiliser"
import { ManureStockEditCtrl } from "./edit/manure/editManure"
import { SeedStockEditCtrl } from "./edit/seeds/editSeeds"
import { createStocksModule } from "./module/module"
import { StocksService } from "./services/service"

export function setup(module: ng.IModule) {

    module

        .service("OmniaStocksService", StocksService)

        .directive("omniaStocks", createStocksModule)

        .directive("omniaStocksAmount", createStockAmount)
        .directive("omniaStocksAmountEdit", createStockAmountEdit)
        .directive("omniaStocksDashboard", StocksDashboardCtrl.create)

        .directive("omniaStocksEdit", StockEditCtrl.create)
        .directive("omniaStocksEditSeeds", SeedStockEditCtrl.create)
        .directive("omniaStocksEditFertiliser", FertiliserStockEditCtrl.create)
        .directive("omniaStocksEditManure", ManureStockEditCtrl.create)

}
